import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { OverflowMenuComponent } from "./overflow-menu.component";
import { TranslateModule } from "@ngx-translate/core";
import { OverlayModule } from '@angular/cdk/overlay';
import { MatIconModule } from '@angular/material/icon';
import { A11yModule } from '@angular/cdk/a11y';

@NgModule({
  declarations: [ OverflowMenuComponent ],
  imports: [ CommonModule, TranslateModule, OverlayModule, MatIconModule, A11yModule ],
  exports: [ OverflowMenuComponent ],
})
export class OverflowMenuModule {}
